import { useMediaQuery } from "@mui/material";
/**
 * Hook to encapsulate the responsiveness for Meal and Item cards
 *
 *
 * @param showDescription
 * @param showImages
 * @returns
 */
export const useResponsiveCard = (showDescription, showImages) => {
    //400px and 360px were the screen sizes listed in the AC
    const smallMobile = useMediaQuery("(max-width:400px)", { noSsr: true });
    const extraSmallMobile = useMediaQuery("(max-width:360px)", { noSsr: true });
    let mobileImageWidth = 125;
    let mobileDisplayNameLines = 1;
    let hideSectionsOnXS = extraSmallMobile;
    let wrapCustomizeButton = "nowrap";
    //We have room for more lines if there is no description
    if (!showDescription) {
        mobileDisplayNameLines = 2;
    }
    //Shrink image to give description more space
    if (showDescription && smallMobile) {
        mobileDisplayNameLines = 1;
        mobileImageWidth = 90;
    }
    //Give the display name an extra line since we have the space
    if (!showDescription && smallMobile) {
        mobileDisplayNameLines = 2;
        mobileImageWidth = 90;
    }
    //Keep image size and give display name extra line
    if (!showDescription && extraSmallMobile) {
        mobileDisplayNameLines = 2;
        mobileImageWidth = 125;
    }
    //Give the display name an extra line since we have the space
    if (!showDescription && (smallMobile || extraSmallMobile)) {
        mobileDisplayNameLines = 2;
    }
    //At this size the description section is hidden so give the display name another line and shrink the image
    //Customize button has to wrap because there is no space
    if (extraSmallMobile) {
        mobileDisplayNameLines = 2;
        mobileImageWidth = 85;
        hideSectionsOnXS = true;
        wrapCustomizeButton = "wrap";
    }
    //if there is no image AND were showing the desc AND were extraSmall, DONT hide it
    if (!showImages && showDescription && extraSmallMobile) {
        hideSectionsOnXS = false;
    }
    return { mobileImageWidth, mobileDisplayNameLines, hideSectionsOnXS, smallMobile, wrapCustomizeButton };
};
